import Bolt from "@mui/icons-material/Bolt"
import { Label } from "@fluentui/react"
import { DEFAULT_USE_CASE_NAME } from "../../utils/constants"

import styles from "./WorkflowBadge.module.css"
import DefaultBadge from "./DefaultBadge";

interface WorkflowBadgeProps {
    useCaseTitle: string;
    showWorkflowBadge: boolean;
}

 const WorkflowBadge = ({ useCaseTitle, showWorkflowBadge } : WorkflowBadgeProps) => {

    return (
      <>
        {
          useCaseTitle != DEFAULT_USE_CASE_NAME &&
          <div className={`${styles.workflowContainer} ${styles.container}`}>
            <div className={`${styles.workflowIconBackground} ${styles.iconBackground}`}>
              <Bolt className={styles.icon}/>
            </div>
            <Label className={styles.workflowTitle}> Workflow: {useCaseTitle}</Label>
          </div>
        }
        { showWorkflowBadge && <DefaultBadge/>}
      </>
    )
 }

 export default WorkflowBadge
